import React from "react";
import { NavDropdown } from "react-bootstrap";

const FilterDropdown = (props) => {

    const handleChange = (item) => {
        console.log(item);
        props.onChange(item);
    };
    return (
        <div className="filter-dropdown">
            <NavDropdown title={props.value || props.label} className="m-0" id="basic-nav-dropdown" >
                {
                    props.options.map((option, index) => {
                        return <NavDropdown.Item key={`tuiop${index}`} onClick={() => handleChange(option)}>{option}</NavDropdown.Item>;
                    })
                }
            </NavDropdown>
        </div>
    );
};

export default FilterDropdown;